// extracted by mini-css-extract-plugin
export default {"container":"ProjectForm_container__ee5Ij","field-container":"ProjectForm_field-container__+z4g6","text-input":"ProjectForm_text-input__mlMtV","label":"ProjectForm_label__jOC9d"};